<template>
    <div class="calendar__alert" data-testid="contact-request-alert">
        <frm-icon name="complication" class="calendar__alert-icon" />

        <p class="calendar__alert-text" v-html="$t('calendar.messages.create-appointment-contact-request.text')" />

        <div class="calendar__alert-actions">
            <button
                type="button"
                class="button button--secondary button--grouped calendar__alert-return"
                data-testid="contact-request-alert:return"
                @click.prevent="returnToContactRequests()"
            >
                <span class="button__icon-group">
                    <frm-icon name="caret-left" class="button__icon" />
                    <span v-if="createAppointmentContactRequestActionRecipientId">
                        {{ $t('calendar.messages.create-appointment-contact-request.return-action') }}
                    </span>
                    <span v-else>
                        {{ $t('calendar.messages.create-appointment-contact-request.return') }}
                    </span>
                </span>
            </button>

            <button
                type="button"
                class="button button--grouped calendar__alert-close"
                data-testid="contact-request-alert:close"
                @click.prevent="closeContactRequestAlert()"
            >
                <span class="button__icon-group">
                    <frm-icon name="cross" class="button__icon" />
                    <span>
                        {{ $t('calendar.messages.create-appointment-contact-request.close') }}
                    </span>
                </span>
            </button>
        </div>
    </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import DialogManager from '../../services/DialogManager';
import OpensContactRequests from '../../mixins/Calendar/OpensContactRequests';

const {
    mapMutations,
    mapState,
} = createNamespacedHelpers('calendar');

export default {
    mixins: [
        OpensContactRequests,
    ],
    computed: {
        ...mapState([
            'createAppointmentContactRequestActionRecipientId',
        ]),
    },
    methods: {
        ...mapMutations([
            'resetCreateAppointmentContactRequestId',
        ]),

        closeContactRequestAlert() {
            DialogManager.confirm(this.$t('calendar.contact-request.confirm-close'))
                .then(() => this.resetCreateAppointmentContactRequestId());
        },

        returnToContactRequests() {
            if (this.createAppointmentContactRequestActionRecipientId) {
                window.location.href = `/dashboard/received-actions/${this.createAppointmentContactRequestActionRecipientId}/edit`;
                return;
            }

            this.resetCreateAppointmentContactRequestId();
            this.openContactRequests();
        },
    },
};
</script>
